import React, { Component } from "react";
import { isEmpty, map } from "lodash";
import * as yup from "yup";
import moment from "moment-timezone";
import { PlusOutlined } from '@ant-design/icons';
import {message, Select} from "antd";
import { convertFirstCharToUppercase } from '../../../../Tools/convertFirstLetterToUppercase';
import { aboutUsData } from "../../../../Assets/data/aboutUsList";

const {Option} = Select;
const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class BasicDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zipcodeCheck: null,
      zipcode: '',
      franchises: [],
      firstName: '',
      lastName: '',
      phone_numbers: [],
      emails: [],
      phone: '',
      phone_type: 'mobile',
      can_send_sms: false,
      email: '',
      customer: {},
      company: '',
      community: '',
      commercialData: {},
      zip_code: '',
      authorizedUser: [],
      error_email_already:false,
      hear_about_us: 'none',
      outreach: ''      
    }
  }

  componentDidMount = () => {
    this.checkZipcode(this.state.zipcode)
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy();
    const { zipcode, zip_code } = this.state;
    this.props.setLoader(false)
    // check zipcode
    if (nextProps?.zipcodeCheck && Object.keys(nextProps?.zipcodeCheck?.data).length > 0 && nextProps?.zipcodeCheck?.data?.results?.length > 0) {
      this.setState({ zipcodeCheck: true, franchises: nextProps?.zipcodeCheck?.data?.results, errors: {} });
    } else {
      this.setState({ zipcodeCheck: false, franchises: [], errors: {} });
    }

    if (!isEmpty(nextProps?.commercialData) && JSON.stringify(nextProps?.commercialData) !== JSON.stringify(this.state.commercialData)) {
      const { commercialData } = nextProps;
      const phone_numbers = commercialData?.phone_numbers?.map(x => ({ ...x, type: x.type || 'home_phone' })) || [];

      let obj = {
        firstName: commercialData?.first_name ? `${commercialData?.first_name}` : '',
        lastName: commercialData?.last_name ? `${commercialData?.last_name}` : '',
        phone_numbers,
        emails: commercialData?.email_address ? [{ email: commercialData?.email_address, primary: true }] : [],
        company: commercialData?.management_company,
        community: commercialData?.community_name,
        //zipcode: zipcode ? zipcode : commercialData?.address?.zip_code ? commercialData?.address?.zip_code : (commercialData.field_office && commercialData.field_office.addressable_zip_codes) ? commercialData.field_office.addressable_zip_codes?.[0] : nextProps?.zipcode,
        zipcode: zip_code ? zip_code : commercialData?.zip_code,
        hear_about_us: commercialData?.hear_about_us,
        outreach: commercialData?.outreach
      }
      this.setState({ ...obj, commercialData }, () => { this.checkZipcode(this.state.zipcode) })
    }


    if (Object.keys(nextProps?.CheckMailStatus.data).length > 0 && nextProps?.CheckMailStatus.data !== this.props.CheckMailStatus.data) {
      if (nextProps?.CheckMailStatus.data?.already_exists)
      {
        message.error('Email address is already in use', 10);
        if (this.state.emails.length > 0) {
          this.state.emails.splice(this.state.emails.findIndex(a => a.email === this.state.emails[this.state.emails.length - 1].email), 1);
        }
      }
    }
  }

  // on service detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({authorizedUser: {...this.state.authorizedUser, [e.target.name]: value},[e.target.name]: value}, () => this.storeInLocal())
  }

  // on primary number changed
  onPrimaryNumberChanged = (index) => {
    const { phone_numbers } = this.state;
    map(phone_numbers, x => x.primary = false)
    Object.assign(phone_numbers[index], { primary: true })
    this.setState({ phone_numbers }, () => this.storeInLocal())
  }

  // on primary email changed
  onPrimaryEmailChanged = (index) => {
    const { emails } = this.state;
    map(emails, x => x.primary = false)
    Object.assign(emails[index], { primary: true })
    this.setState({ emails }, () => this.storeInLocal())
  }

  //on change
  onChange = (row, name) => {
    const { phone_numbers, emails, authorizedUser } = this.state;
    let data = name === 'phone' ? phone_numbers : name === 'email' ? emails : authorizedUser;
    data.splice(row, 1);
    if (name === 'phone' || name === 'email') {
      const idx = data?.findIndex(x => x.primary)
      if (idx <= -1 && data?.length > 0) data[0].primary = true
    }
    this.setState({ [name === 'phone' ? 'phone_numbers' : name === 'email' ? 'emails' : 'authorizedUser']: data }, () => this.storeInLocal());
  };

  //on add
  onAdd = (name) => {
    const { phone_numbers, emails, phone, can_send_sms, phone_type, email, hear_about_us } = this.state;
    if (name === 'phone') {
      if (isEmpty(phone_numbers)) {
        phone_numbers[0] = { phone: phone, can_send_sms, primary: phone_numbers.length === 0, type: phone_type };
      } else {
        let check = can_send_sms=== "" ? false : can_send_sms ;
        phone_numbers.push({ phone: phone,can_send_sms : check, primary: phone_numbers.length === 0, type: phone_type });
      }
      this.setState({ phone_numbers }, () => {
        this.onClear('phone'); this.onClear('phone_type'); this.onClear('can_send_sms')}, () => this.storeInLocal());
    } else if (name === 'email') {
      emails.push({ email, primary: emails.length === 0 });
      this.setState({ emails }, () => { this.onClear('email'); }, () => this.storeInLocal());
    }

    if(name === 'email' && emails.length >1){
      this.setState({error_email_already : true})
    }
  };

  // on clear
  onClear = (value) => {
    this.setState({ [value]: '' }, () => this.storeInLocal());
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // check for logged in user zipcode
  checkedLoggedInUserZipcode = (zipCode) => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    if (!isEmpty(authUser) && authUser.user.zip_codes) {
      return authUser.user.zip_codes.includes(zipCode)
    }
    return false
  }

  // on zip code changed
  onZipcodeChange = (e) => {
    const zipcode = e.target.value;
    this.setState({ zipcode: e.target.value, zip_code: e.target.value}, () => {
      if (zipcode.length === 5) {
        const checkedZipcode = this.checkedLoggedInUserZipcode(zipcode)
        if (checkedZipcode) {
          this.checkZipcode(zipcode)
        } else {
          this.setState({zipcodeCheck: false}, () => {
            this.storeInLocal()
            this.props.resetCheckZipcode()
          })
        }
      } else {
        this.setState({ zipcodeCheck: false }, () => {
          // this.storeInLocal()
          // this.props.resetCheckZipcode()
        })
      }
    });
  };

  // check zipcode
  checkZipcode = (value) => {
    if (value) {
      this.storeInLocal()
      this.props.setLoader && this.props.setLoader(true);
      this.props.checkZipCode({ addressable_zip_codes__contains: value, close: false }); // check zip code
    }
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    if (!phone) return ''
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  storeInLocal = () => {
    const {
      phone_numbers,
      emails,
      firstName,
      lastName,
      company,
      community,
      zipcode,
      authorizedUser,
      hear_about_us,
      outreach
    } = this.state;
    const email = emails.find(x => x.primary === true)
    let obj = {
      zipcode,
      first_name: firstName || '',
      last_name: lastName || '',
      management_company: company,
      community_name: community,
      email_address: email?.email,
      phone_numbers: phone_numbers,
      hear_about_us,
      authorizedUser,
      outreach,
      emails
    }
    this.props.setCommercialData(obj);
  }

  // validate required fields
  validate = () => {
    const {
      phone_numbers,
      firstName,
      lastName,
      zipcodeCheck,
      emails,
      zipcode,
      community,
      outreach,
      hear_about_us,
    } = this.state;

    const schema = yup.object().shape({
      zipcode: yup.string().required('Zipcode is required'),
      zipcodeCheck: yup.bool().oneOf([true]),
      firstName: yup.string().required('First name is required'),
      lastName: yup.string().required('Last name is required'),
      phone_numbers: yup.array(yup.object({
        phone: yup.string().required('Phone is required'),
        type: yup.string().required('type is required')
      })).required("Phone number is required"),
      emails: yup.array(yup.object({
        email: yup.string().required('Email is required')
      })).required("Email Address is required"),
      community: yup.string().required('Community name is required.'),
    });

    const data = {
      zipcode,
      zipcodeCheck,
      firstName,
      lastName,
      phone_numbers,
      emails,
      community,
      hear_about_us,
      outreach: outreach !== "" ? outreach : "call_center"
    };
    return schema.validate(data, { abortEarly: false }).then(() => {
      this.props.setZipCode(zipcode);
      return Promise.resolve('success')
    }).catch((error) => {
      let err_data = {};
      map(error.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data, is_btn_active: false})
      return Promise.reject('fail')
    });
  };

  // render phone numbers
  renderPhoneNumbers = () => {
    const { phone_numbers, phone, phone_type, can_send_sms, errors, zipcodeCheck } = this.state;
    return (
      <div>
        <h5 className=" mt-30">Phone Numbers</h5>
        <div className="inline-check-list gcheck">
          {
            map(phone_numbers, (item, index) => <div className="fitem-check" key={`phoneNumber${index}`}>
              <input type="checkbox" className="fitem-ck-input" disabled={!zipcodeCheck} id={`checkboxPhone${index}`} name={`checkboxPhone${index}`} checked={item?.primary} onChange={() => this.onPrimaryNumberChanged(index)} />
              <label htmlFor={`checkboxPhone${index}`} className="fitem-ck-txt black">{`+1 ${this.formatPhoneNumber(item?.phone)} ${item?.primary ? '(Primary)' : ''}`}</label>
              <a className="red float-right" href="/#" onClick={(e) => {e.preventDefault(); this.onChange(index, 'phone')}}><u>Remove</u></a>
            </div>)
          }
        </div>
        <div className="fitem fitem-rinner mt-10 flex">
          <input name="phone" type="text" placeholder="Add New Phone Number" value={phone} maxLength={"10"} disabled={!zipcodeCheck}
            max={"10"} onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTextChange(e)} />
          <Select
            onChange={(e) => this.onTextChange({target: {name: 'phone_type', value: e}}) }
            style={{marginLeft: "8px", marginRight: "8px"}}
            name="phone_type"
            value={phone_type}
            placeholder="Type">
            <Option value="home_phone">Home</Option>
            <Option value="mobile">Mobile</Option>
          </Select>
          <button className={`btn ${phone.length !== 10 ? 'disabled' : 'btn-warning'}`}
            disabled={phone.length !== 10} onClick={() => this.onAdd('phone')}><PlusOutlined /></button>
        </div>
        {phone_type === 'mobile' ? <div className="fitem-check">
          <input
            type="checkbox"
            className="fitem-ck-input"
            id={`can_send_sms`}
            onChange={(e) => this.onTextChange(e, 'bool')}
            checked={can_send_sms}
            name="can_send_sms" />
          <label htmlFor={`can_send_sms`} className="fitem-ck-txt">{`Send SMS updates about my service to this number.`}</label>
        </div> : ''}
        {errors?.[`phone_numbers`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`phone_numbers`]}</label> : ''}
      </div>
    )
  }

  // Render email addresses
  renderEmails = () => {
    const {emails, email, errors, zipcodeCheck , error_email_already} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Email Addresses</h5>
        <div className="inline-check-list gcheck">
          {map(emails, (item, index) => <div className="fitem-check" key={`emails${index}`}>
            <input type="checkbox" className="fitem-ck-input" disabled={!zipcodeCheck} id={`checkboxEmail${index}`} name={`checkboxEmail${index}`} checked={item?.primary} onChange={() => this.onPrimaryEmailChanged(index)} />
            <label htmlFor={`checkboxEmail${index}`} className="fitem-ck-txt black">{`${item?.email} ${item?.primary ? '(Primary)' : ''}`}</label>
            <a className="red float-right" href="/#" onClick={(e) => {e.preventDefault(); this.onChange(index, 'email')}}><u>Remove</u></a>
          </div>
          )}
        </div>
        <div className="fitem fitem-rinner mt-10">
          <input
            name="email"
            type="text"
            value={email}
            disabled={!zipcodeCheck}
            placeholder="Add New Email Address"
            onChange={(e) => this.onTextChange(e)}
          />
          <button className={`btn fitem-ricon ${!REGULAR_EXPRESSION_EMAIL.test(email) ? 'disabled' : 'btn-warning'}`}
            disabled={!REGULAR_EXPRESSION_EMAIL.test(email)} onClick={() => { this.props.checkMail(email); this.onAdd('email'); }}><PlusOutlined /></button>
        </div>
        {errors?.[`emails`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`emails`]}</label> : ''}
        {error_email_already ? <label className="new_err_msg"><i className="las la-info-circle"/>Can add only one email address</label> : ''}
      </div>
    )
  };

  // render authorized proposal
  renderAuthorizedUsers = () => {
    const { authorizedUser, username, zipcodeCheck } = this.state;
    return (
      <div>
        <h5 className=" mt-30">Authorized Users</h5>
        <div className="inline-check-list gcheck">
          {map(authorizedUser, (item, index) => <div className="fitem-check flex" key={`user${index}`}>
            <b className="d-block">{item?.username}</b>
            <div className="flex">
              <span className="mr-2">{`Added ${moment(item?.created_at)?.format('MM/DD/YYYY')}`}</span>
              <a className="red" href={'/#'} onClick={(e) => { e.preventDefault(); this.onChange(index, 'authorizedUser') }}><u>Remove</u></a>
            </div>
          </div>
          )}
        </div>
        <div className="fitem fitem-rinner mt-10">
          <input name="username" type="text" placeholder="Add New Authorized User" value={username} disabled={!zipcodeCheck}
            onChange={(e) => this.onTextChange(e)} />
          <button className={`btn fitem-ricon ${!username ? 'disabled' : 'btn-warning'}`}
            disabled={!username} onClick={() => this.onAdd('authorizedUser')}><PlusOutlined /></button>
        </div>
      </div>
    )
  }

  // On service detail change
  // onTextChangeSource = (e, type) => {
  //   this.setState({{authorizedUser: {...this.state.authorizedUser, [e.target.name]: value}, hear_about_us: e.target.value}, () => this.setState({isLocalValueChanged: true}));
  // }

  // on service detail change
  onTextChangeSource = (e) => {

    if(e.target.name === 'hear_about_us')
    {
      this.setState({
        authorizedUser: {...this.state.authorizedUser, 
          hear_about_us: [e.target.value]}, 
        hear_about_us: [e.target.value]}, 
      () => this.storeInLocal()
      );
    }

    if(e.target.name === 'outreach')
    {
      this.setState({outreach: e.target.value}, 
        () => this.storeInLocal()
      );
    }
  }

  // render Lead source
  renderLeadSource = () => {
    const {hear_about_us, outreach, errors} = this.state;
    return (
      <React.Fragment>
        <div>
          <h5 className=" mt-30">How did you hear about us</h5>
          <div className="inline-check-list gcheck">
            <Select
              name="hear_about_us"
              value={hear_about_us}
              placeholder="Select the source"
              onChange={(e) => this.onTextChangeSource({ target: { name: 'hear_about_us', value: e } })}
            >
              <Option value='none' selected disabled>Select</Option>
              {aboutUsData?.map((item) => (
                <Option id={item.id} value={item.value} key={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </div>
        </div>
        <div>
          <h5 className=" mt-30">Outreach</h5>
          <div className="inline-check-list gcheck">
            <Select
              id="outreach"
              name="outreach"
              value={convertFirstCharToUppercase(outreach)}
              disabled={outreach === "website" ? true : false}
              placeholder="Select the outreach"
              onChange={(e) => this.onTextChangeSource({target: {name: 'outreach', value: e}})}
            >
              <Option value="" selected disabled>Select the outreach</Option>
              <Option value="franchisee">Franchisee</Option>
              <Option value="call_center">Call Center</Option>
            </Select>
          </div>
          {errors?.['outreach'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['outreach']}</label> : ''}
        </div>
      </React.Fragment>
    )
  };
  

  render() {
    const {
      zipcodeCheck,
      zipcode,
      franchises,
      firstName,
      lastName,
      company,
      community,
      errors
    } = this.state;
    const franchiseName = franchises?.map((obj) => obj?.name) || [];

    return (
      <div className="aleft">
        <h4>Do we service this area?</h4>
        <p>If you are here, this is for a new customer calling right now. First of all, take their zipcode for their service address to make sure we service this area.</p>
        <div className="form-group">
          <div className="fitem">
            <label>Service Zipcode</label>
            <input type="text" placeholder="Zipcode" name="zipcode" max={5} maxLength={5} value={zipcode || ''}
              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onZipcodeChange(e)} />
            {errors?.[`zipcode`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`zipcode`]}</label> : ''}
          </div>
          {zipcode ? zipcodeCheck ? <div className="greenbox mb-30">
            <b className="d-block">We cover this area.</b>
            <b className="d-block">{`This is under the ${franchiseName?.toString()} Franchise.`}</b>
          </div> :
            <div className="dangerbox mb-30">
              <b className="d-block">We don’t currently have any franchises covering this area. Save their email to notify them if we move into this area. </b>
            </div> : ''}
        </div>
        <div className="form-group">
          {zipcodeCheck && <h4>Contact Information</h4>}
          {zipcodeCheck && <div className="fitem half-fitem">
            <div className="fitem half-fitem">
              <label>First Name</label>
              <input type="text" placeholder="First Name" name="firstName" value={firstName} onChange={(e) => this.onTextChange(e)} />
              {errors['firstName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['firstName']}</label> : ''}
            </div>
            <div className="fitem half-fitem">
              <label>Last Name</label>
              <input type="text" placeholder="Last Name" name="lastName" value={lastName} onChange={(e) => this.onTextChange(e)} />
              {errors['lastName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['lastName']}</label> : ''}
            </div>
          </div>}
          {zipcodeCheck && <div className="fitem">
            <label>Management Company</label>
            <input type="text" placeholder="Management Company" disabled={!zipcodeCheck} name="company" value={company} onChange={(e) => this.onTextChange(e)} />
          </div>}
          {zipcodeCheck && <div className="fitem">
            <label>Community Name</label>
            <input type="text" placeholder="Community Name" disabled={!zipcodeCheck} name="community" value={community || ''} onChange={(e) => this.onTextChange(e)} />
            {errors?.[`community`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`community`]}</label> : ''}
          </div>}

        </div>
        {zipcodeCheck ? this.renderPhoneNumbers() : ''}
        {zipcodeCheck ? this.renderEmails() : ''}
        {this.renderLeadSource()}
      </div>
    )
  }
}

export default BasicDetail;